import { motion } from "framer-motion";
import { ShieldCheck, Truck, Clock, BadgeEuro } from "lucide-react";

const WORKSHOP_IMG =
  "https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxjYXIlMjBtZWNoYW5pYyUyMHJlcGFpcmluZyUyMGVuZ2luZSUyMGhvb2R8ZW58MHx8fHwxNzkyODMwNjkwfDA&ixlib=rb-4.1.0&q=85";

const cards = [
  {
    icon: Truck,
    title: "Envío express 24/48h",
    desc: "Entrega directa en tu taller de confianza o en tu domicilio, en toda España.",
    testid: "why-card-shipping",
  },
  {
    icon: Clock,
    title: "Servicio 24H los 365 días",
    desc: "Atención por WhatsApp a cualquier hora, todos los días del año. Si es urgente, lo tratamos como urgente.",
    testid: "why-card-24h",
  },
  {
    icon: BadgeEuro,
    title: "Ahorro de hasta un 70%",
    desc: "Comparado con el recambio oficial de concesionario. Mismo encaje, menos precio.",
    testid: "why-card-savings",
  },
];

const item = {
  hidden: { opacity: 0, y: 28 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] } },
};

export const WhyUs = () => (
  <section id="ventajas" className="py-24 sm:py-32 bg-industrial-900/40 border-y border-industrial-700/60" data-testid="why-us-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-12"
      >
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-brand-amber mb-4">Por qué nosotros</p>
        <h2 className="font-display font-black uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
          Recambios con <span className="text-outline">respaldo real</span>
        </h2>
      </motion.div>

      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-60px" }}
        transition={{ staggerChildren: 0.12 }}
        className="grid md:grid-cols-3 gap-4"
      >
        <motion.div
          variants={item}
          className="md:col-span-2 md:row-span-2 relative overflow-hidden rounded-sm border border-industrial-700 min-h-[320px] group"
          data-testid="why-card-verified"
        >
          <img src={WORKSHOP_IMG} alt="Mecánico verificando un motor" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-industrial-950 via-industrial-950/40 to-transparent" />
          <div className="absolute bottom-0 p-6 sm:p-8">
            <ShieldCheck className="w-8 h-8 text-brand-amber mb-3" />
            <h3 className="font-display font-extrabold uppercase tracking-wide text-2xl sm:text-3xl mb-2">100% piezas verificadas</h3>
            <p className="text-slate-300 text-sm sm:text-base max-w-md">
              Comprobamos el estado operacional de cada recambio antes del envío. Si no pasa nuestra inspección, no sale del almacén.
            </p>
          </div>
        </motion.div>
        {cards.map((c) => (
          <motion.div
            key={c.title}
            variants={item}
            className="bg-industrial-850 border border-industrial-700 rounded-sm p-6 sm:p-8 hover:border-brand-amber/60 hover:bg-industrial-800 transition-colors duration-300 group"
            data-testid={c.testid}
          >
            <c.icon className="w-7 h-7 text-brand-orange mb-4 transition-transform duration-300 group-hover:-translate-y-1" />
            <h3 className="font-display font-bold uppercase tracking-wider text-xl mb-2">{c.title}</h3>
            <p className="text-slate-400 text-sm leading-relaxed">{c.desc}</p>
          </motion.div>
        ))}
      </motion.div>
    </div>
  </section>
);
